import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import INPUTCHECKBOX from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTCHECKBOX.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
import Clickable from '../../../../../../../../interface/Clickable.js';
// Model Structure
export const formInputCheckboxAttr = makeAttrStruct([
    ['class']
]);
export const formInputCheckboxData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputCheckboxModel = makeStruct([
    ['attributes', formInputCheckboxAttr],
    ['data', formInputCheckboxData]
]);
// Simplified Model
export function formInputCheckbox(label, field, message, buttons) {
    return {
        attributes: formInputCheckboxAttr(),
        data: formInputCheckboxData(label, field, message, buttons)
    };
}
/** Represents an Input[type=Checkbox] for a Form */
export default class FORMINPUTCHECKBOX extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
        this.implement(new Clickable(this));
        if (model.attributes.checked) {
            this.getField().setAttribute('checked', 'true');
        }
        else {
            this.getField().removeAttribute('checked');
        }
        this.on('click', (event) => {
            if (!this.hasClass('active')) {
                this.activateFormField(event);
            }
        }).on('activate', (event) => {
            this.activateFormField(event);
        });
    }
    createField(model) {
        return new INPUTCHECKBOX(this, model);
    }
}
